import { orderBy } from 'lodash'

import { Upload } from './types'

export const sortUploads = (uploads: Upload[]) => {
  return orderBy(uploads, 'addedDate', 'desc')
}
